import {
  PRESUPUESTADOR_DELETE_BUDGET_BEGIN,
  PRESUPUESTADOR_DELETE_BUDGET_SUCCESS,
  PRESUPUESTADOR_DELETE_BUDGET_FAILURE,
  PRESUPUESTADOR_DELETE_BUDGET_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { getEndpoint } from '../../common/backend/endpoints'

export function deleteBudget(id) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_DELETE_BUDGET_BEGIN,
    });

    const endpoint = getEndpoint('PRESUPUESTADOR')

    const {presupuestador = {}} = getState()

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(endpoint+"/"+id)
      doRequest.then(
        (res) => {
          // Elimino el presupuesto de la lista en el store
          let listaAux = presupuestador.listaDePresupuestos
          listaAux.forEach((pres, i)=>{
            if(pres.id === id){
              listaAux.splice(i,1)
            }
          })
          dispatch({
            type: PRESUPUESTADOR_DELETE_BUDGET_SUCCESS,
            data: listaAux,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_DELETE_BUDGET_FAILURE,
            data: { error: err.response.data },
          });
          reject(err);
        },
      )
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteBudgetError() {
  return {
    type: PRESUPUESTADOR_DELETE_BUDGET_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_DELETE_BUDGET_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteBudgetPending: true,
        deleteBudgetError: null,
      };

    case PRESUPUESTADOR_DELETE_BUDGET_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteBudgetPending: false,
        deleteBudgetError: null,
        listaDePresupuestos: action.data
      };

    case PRESUPUESTADOR_DELETE_BUDGET_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteBudgetPending: false,
        deleteBudgetError: action.data.error,
      };

    case PRESUPUESTADOR_DELETE_BUDGET_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteBudgetError: null,
      };

    default:
      return state;
  }
}
